export default {
  data() {
    return {
      showRequestSuccessfulMessage: false,
      showRequestSuccessfulMessageDuration: 2000
    }
  },
  methods: {
    async sendSurveyNote(newsID, surveyID) {
      const input = this.$refs['ref-survey-' + surveyID]

      if (!input) {
        return
      }
      await this.$store.dispatch('saveNewsSurveyCustomReply', {
        newsID: newsID,
        surveyID: surveyID,
        customAnswer: input[0].value
      })

      this.showRequestSuccessfulMessage = true
      window.setTimeout(() => this.showRequestSuccessfulMessage = false, this.showRequestSuccessfulMessageDuration)
    },
    async confirmSurvey(newsID, surveyID, answerID, checked) {
      await this.$store.dispatch('saveNewsSurveyReply', {
        newsID: newsID,
        surveyID: surveyID,
        answerID: answerID,
        checked: checked
      })
    }
  }
}
